<div class="flex flex-col lg:flex-row min-h-full py-1">
  <app-skills class="w-full md:basis-2/7 mx-1 mt-1 rounded-sm"></app-skills>
  <app-inputs class="w-full md:basis-2/7 mx-1 mt-1 rounded-sm"></app-inputs>
  <app-outputs class="w-full md:basis-3/7 mx-1 mt-1 rounded-sm"></app-outputs>
</div>
